/** @format */

import { Route } from "react-router-dom";
import AgentRootBeforeRender from "../pages/common/AgentRootBeforeRender";
import RedirectBeforeRender from "../pages/common/RedirectBeforeRender";
import BeforeRender from "../pages/common/BeforeRender";

import { EmochiEntryColumn } from "../components/ui_elements/emochi/Entry/EntryColumn";
import EmochiEntry from "../pages/emochi/Entry";
import EmochiEconomicEstimate from "../pages/emochi/EconomicEstimate";
import EmochiEconomicEstimateCheck from "../pages/emochi/EconomicEstimateCheck";
import EmochiEntryTop from "../pages/emochi/EntryTop";
import EmochiEconomicSelect from "../pages/emochi/EconomicSelect";

// 共通ページ
import Login from "../pages/common/Login";
import ResetPassword from "../pages/common/ResetPassword";
import ResetPasswordMail from "../pages/common/ResetPasswordMail";
import ResetPasswordMailCompleted from "../pages/common/ResetPasswordMailCompleted";
import ChangePasswordMail from "../pages/common/ChangePasswordMail";

import EntrySelect from "../pages/emochi/EntrySelect";
import SystemError from "../pages/common/SystemError";
import RedirectTimeout from "../pages/common/RedirectTimeout";
import DashBoard from "../pages/common/DashBoard";

// redirect
import RedirectPassword from "../pages/common/RedirectPassword";
import EmochiRedirectEconomic from "../pages/emochi/RedirectEconomic";

import EntryConfirm from "../pages/emochi/EntryConfirm";
import EntryCompleted from "../pages/emochi/EntryCompleted";
import UseStart from "../pages/emochi/UseStart";
import ExaminationStatus from "../pages/emochi/ExaminationStatus";
import Inquiry from "../pages/common/Inquiry";
import FinalAgreement from "../pages/emochi/FinalAgreement";
import FinalAgreementCompleted from "../pages/emochi/FinalAgreementCompleted";
import UseStartPrecautions from "../pages/common/UseStartPrecautions";
import EntryCheck from "../pages/emochi/EntryCheck";

const EmochiRouting = [
  <Route path="emochi" element={<AgentRootBeforeRender agentPath="/emochi" />}>
    <Route path="login" element={<BeforeRender Component={Login} IsLoggedIn={false} />} />
    <Route path="system_error" element={<BeforeRender Component={SystemError} IsLoggedIn={false} />} />
    <Route path="redirect_timeout" element={<BeforeRender Component={RedirectTimeout} IsLoggedIn={false} />} />
    <Route path="reset_password_mail" element={<BeforeRender Component={ResetPasswordMail} IsLoggedIn={false} />} />
    <Route
      path="reset_password_mail_completed"
      element={<BeforeRender Component={ResetPasswordMailCompleted} IsLoggedIn={false} />}
    />
    <Route path="economic_estimate" element={<BeforeRender Component={EmochiEconomicEstimate} />} />
    <Route path="economic_estimate_check" element={<BeforeRender Component={EmochiEconomicEstimateCheck} />} />
    <Route
      path="redirect/economic_estimate_check"
      element={<RedirectBeforeRender Component={EmochiEconomicEstimateCheck} redirect={true} />}
    />
    <Route path="reset_password" element={<BeforeRender Component={ResetPassword} IsLoggedIn={false} />} />
    <Route path="entry_top" element={<BeforeRender Component={EmochiEntryTop} />} />
    <Route path="economic_select" element={<BeforeRender Component={EmochiEconomicSelect} />} />
    <Route path="entry" element={<BeforeRender Component={EmochiEntry} />}>
      <Route path="merchant" element={<EmochiEntryColumn path="merchant" />} />
      <Route path="bank_account" element={<EmochiEntryColumn path="bank_account" />} />
      <Route path="shop" element={<EmochiEntryColumn path="shop" />} />
    </Route>
    <Route
      path="redirect_economic_select"
      element={<RedirectBeforeRender Component={EmochiEconomicSelect} redirect={true} />}
    />
    <Route
      path="redirect_economic_estimate"
      element={<RedirectBeforeRender Component={EmochiRedirectEconomic} redirect={true} />}
    />
    <Route path="entry_select" element={<BeforeRender Component={EntrySelect} IsLoggedIn={false} />} />
    <Route path="change_password_mail" element={<BeforeRender Component={ChangePasswordMail} />} />
    <Route path="dashboard" element={<BeforeRender Component={DashBoard} />} />
    <Route path="redirect" element={<RedirectBeforeRender Component={EmochiEntry} redirect={true} />}>
      <Route path="merchant" element={<EmochiEntryColumn path="merchant" redirect={true} />} />
      <Route path="bank_account" element={<EmochiEntryColumn path="bank_account" redirect={true} />} />
      <Route path="shop" element={<EmochiEntryColumn path="shop" redirect={true} />} />
    </Route>
    <Route path="redirect_password" element={<RedirectBeforeRender Component={RedirectPassword} redirect={true} />} />
    <Route path="redirect_confirm" element={<RedirectBeforeRender Component={EntryConfirm} redirect={true} />} />
    <Route path="redirect_completed" element={<RedirectBeforeRender Component={EntryCompleted} />} />
    <Route path="entry_check" element={<BeforeRender Component={EntryCheck} />} />
    <Route path="entry_confirm" element={<BeforeRender Component={EntryConfirm} />} />
    <Route path="entry_completed" element={<BeforeRender Component={EntryCompleted} />} />
    <Route path="use_start" element={<BeforeRender Component={UseStart} />} />
    <Route path="examination_status" element={<BeforeRender Component={ExaminationStatus} />} />
    <Route path="final_agreement" element={<BeforeRender Component={FinalAgreement} />} />
    <Route path="final_agreement_completed" element={<BeforeRender Component={FinalAgreementCompleted} />} />
    <Route path="inquiry" element={<BeforeRender Component={Inquiry} />} />
    <Route path="use_start_precautions" element={<BeforeRender Component={UseStartPrecautions} />} />
  </Route>,
];

export default EmochiRouting;
